import { BarDatum } from "@nivo/bar";
import { SeriesFormat } from "./types";

// Acumula os valores das keys especificadas
export const accumulatedData = ({
  data,
  keys,
}: {
  data: BarDatum[];
  keys: string[];
}): BarDatum[] => {
  // Inicializa acumuladores por key
  const totals: Record<string, number> = {};

  return data.map((item) => {
    const newItem: BarDatum = { ...item };

    keys.forEach((key) => {
      const currentValue = Number(item[key]) || 0;
      totals[key] = (totals[key] || 0) + currentValue;
      newItem[key] = totals[key];
    });

    return newItem;
  });
};

export const accumulatedSeries = ({
  data,
}: {
  data: SeriesFormat[];
}): SeriesFormat[] => {
  return data.map((series) => {
    let accumulated = 0;

    const newData = series.data.map((point) => {
      accumulated += Number(point.y) || 0;
      return {
        ...point,
        y: accumulated,
      };
    });

    return {
      ...series,
      data: newData,
    };
  });
};
